
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill-current",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.04.53L10 .5h-.03l.07.03zM2.96 7.97l.6-.6a5.5 5.5 0 01-.2-.14L0 4.7l3.37-2.52a5.5 5.5 0 013.3-1.1h1c.64 0 1.27.11 1.86.32l.73-.73.87.58-.62.62.46.3 3.36 2.53-3.36 2.53a5.5 5.5 0 01-3.3 1.1h-1a5.5 5.5 0 01-2.17-.45l-.58.58L3 8l-.04-.03zm4.2-6.27c.6 0 1.14.17 1.6.47L4.64 6.3a3 3 0 012.54-4.6zm2.37 1.16l-4.21 4.2a3 3 0 004.21-4.21z","fill":"#8A8888"}})])
          )
        }
      }
    